import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes, { string } from "prop-types";
import PulseLoader from "react-spinners/PulseLoader";
import i18next from "i18next";
import axios from "axios";
import { getDateFormat } from "@utils/datePickerUtils";
import { Button, Image, Anchor } from "hesus-ui-kit";
import removalIcon from "@icons/ic-removal-product.svg";
import supplyIcon from "@icons/ic-supply-product.svg";
import otherIcon from "@icons/ic-enquiry-type-other.svg";
import priorityUrgentIcon from "@icons/ic-priority-urgent.svg";
import priorityNormalIcon from "@icons/ic-priority-normal.svg";
import priorityLowIcon from "@icons/ic-priority-low.svg";
import priorityNoIcon from "@icons/ic-no-priority.svg";
import {
  DashboardContainerSection,
  GridRow,
  GridSubItem,
  GridSubLabel,
  ButtonWrapper,
} from "../../DashboardView.styled";
import "../../DashboardView.scss";

/**
 * Dashboard enquiries List,
 * Path - /
 * @see See [https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3354886162/Widget+1+-+Last+enquiries+to+process)
 * @component
 */
const DashboardEnquiryList = (props) => {
  const { t, widgetName, widgetId, userId, countryId } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [requestData, setRequestData] = useState([]);

  const fetchRequestInfo = () => {
    axios
      .get(`/dashboard/${userId}/widgets/${widgetId}?countryId=${countryId}`)
      .then((response) => {
        setIsLoading(false);
        setRequestData(response.data[0]);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    fetchRequestInfo();
  }, []);

  const getPriorityIcon = (priority) => {
    let icon = priorityNoIcon;
    if (priority === 3) {
      icon = priorityLowIcon;
    }
    if (priority === 2) {
      icon = priorityNormalIcon;
    }
    if (priority === 1) {
      icon = priorityUrgentIcon;
    }
    return icon;
  };

  const getPriorityText = (priority) => {
    let icon = "ENQUIRY_PRIORITY_NOT_DEFINED";
    if (priority === 3) {
      icon = "ENQUIRY_PRIORITY_LOW";
    }
    if (priority === 2) {
      icon = "ENQUIRY_PRIORITY_NORMAL";
    }
    if (priority === 1) {
      icon = "ENQUIRY_PRIORITY_HIGH";
    }
    return icon;
  };

  const getDueDateColor = (dueDate) => {
    let dueDateColor = "E83F1E";
    let currentDate = new Date();
    const newCurrentDate = new Date();
    currentDate = currentDate.setDate(currentDate.getDate() + 1);

    const dueDateTIme = new Date(dueDate).getTime();

    if (dueDateTIme > currentDate) {
      dueDateColor = "#32A728";
    }
    if (currentDate === dueDateTIme || newCurrentDate > dueDateTIme) {
      dueDateColor = "#F08046";
    }
    if (newCurrentDate > dueDateTIme) {
      dueDateColor = "#E83F1E";
    }
    return dueDateColor;
  };

  return (
    <DashboardContainerSection className="widget-list">
      {isLoading && (
        <div className="suggestions-list-loading">
          <PulseLoader color="#1bace4" size={15} />
        </div>
      )}
      <GridRow
        borderBottom="2px solid #cccccc"
        padding="0px 0px 5px"
        marginBottom="7px"
      >
        <GridSubItem fontWeight="700" fontStyle="normal" fontSize="20px">
          {t(widgetName)}
        </GridSubItem>
      </GridRow>
      {!isLoading && requestData?.results?.length === 0 && (
        <GridRow marginBottom="10px" column="1fr" gap="1%">
          <GridSubItem
            fontStyle="normal"
            fontSize="16px"
            color="#474747"
            textAlign="center"
          >
            {t("NO_DATA")}
          </GridSubItem>
        </GridRow>
      )}
      {!isLoading && requestData?.results?.length > 0 && (
        <>
          <GridRow marginBottom="10px" column="10% 55% 15% 17%" gap="1%">
            <GridSubItem fontStyle="normal" fontSize="14px" color="#474747">
              {t("WIDGET_ENQUIRY_SERVICE_TYPE")}
            </GridSubItem>
            <GridSubItem fontStyle="normal" fontSize="14px" color="#474747">
              {t("WIDGET_ENQUIRY_SITE")}
            </GridSubItem>
            <GridSubItem
              fontStyle="normal"
              fontSize="14px"
              color="#474747"
              textAlign="center"
            >
              {t("WIDGET_ENQUIRY_PRIORITY")}
            </GridSubItem>
            <GridSubItem
              fontStyle="normal"
              fontSize="14px"
              color="#474747"
              textAlign="center"
            >
              {t("WIDGET_ENQUIRY_DUE_DATE")}
            </GridSubItem>
          </GridRow>
          {requestData.results.map((request, requestIndex) => {
            return (
              <GridRow
                key={
                  "dashboard-request-list-" + request.id + "-" + requestIndex
                }
                borderBottom={
                  requestIndex + 1 === requestData.results.length
                    ? "0px solid #cccccc"
                    : "1px solid #cccccc"
                }
                column="10% 55% 15% 17%"
                gap="1%"
                padding="5px 0px"
              >
                <GridSubLabel
                  fontWeight="700"
                  fontStyle="normal"
                  fontSize="20px"
                >
                  {request?.serviceType === "DELIVERY" && (
                    <Image
                      src={removalIcon}
                      alt={t("ENQUIRY_SERVICE_TYPE_SUPPLY")}
                      title={t("ENQUIRY_SERVICE_TYPE_SUPPLY")}
                      className="dashboard-widget-view-site__image_view_icon"
                    />
                  )}
                  {request?.serviceType === "EVACUATION" && (
                    <Image
                      className="dashboard-widget-view-site__image_view_icon"
                      src={supplyIcon}
                      alt={t("ENQUIRY_SERVICE_TYPE_REMOVAL")}
                      title={t("ENQUIRY_SERVICE_TYPE_REMOVAL")}
                    />
                  )}
                  {request?.serviceType === "NONE" && (
                    <Image
                      className="dashboard-widget-view-site__image_view_icon"
                      src={otherIcon}
                      alt={t("ENQUIRY_SERVICE_TYPE_OTHER")}
                      title={t("ENQUIRY_SERVICE_TYPE_OTHER")}
                    />
                  )}
                </GridSubLabel>
                <GridSubItem>
                  <GridRow>
                    <GridSubItem
                      fontWeight="700"
                      fontStyle="normal"
                      fontSize="16px"
                    >
                      <Anchor
                        url={`/site/view/${request.site.id}/enquiry-view-${request.id}`}
                        className="dashboard-widget-view-site__link"
                        target="_blank"
                      >
                        {"#" + request.id} -{" "}
                        {request.quantity + " " + t(request.unit)}
                        {" - "}
                        {request.productName}
                      </Anchor>
                    </GridSubItem>
                    <GridSubItem fontSize="14px" color="#474747">
                      {request.site?.id + " - " + request.site?.name}
                    </GridSubItem>
                  </GridRow>
                </GridSubItem>
                <GridSubLabel textAlign="center">
                  <Image
                    className="dashboard-widget-view-site__image_view_icon"
                    src={getPriorityIcon(parseInt(request?.priority, 10))}
                    alt={t(getPriorityText(parseInt(request?.priority, 10)))}
                    title={t(getPriorityText(parseInt(request?.priority, 10)))}
                  />
                </GridSubLabel>
                <GridSubLabel
                  color={getDueDateColor(request.dueDate)}
                  fontWeight="700"
                  fontStyle="normal"
                  fontSize="16px"
                  textAlign="center"
                >
                  {request.dueDate
                    ? getDateFormat(request.dueDate, "YYYY-MM-DD")
                    : " - "}
                </GridSubLabel>
              </GridRow>
            );
          })}
        </>
      )}
      <GridRow>
        <ButtonWrapper>
          <Button
            styles={{
              padding: "5px",
              color: "#00AEEA",
              background: "#fff",
              fontWeight: "700",
              border: "1px solid #00AEEA",
              "&:hover": {
                backgroundColor: "#fff",
              },
            }}
            onClick={() => window.open(`/request/list/to-process`, "_blank")}
          >
            {t("WIDGET_ACTION_SEE_ALL")}
          </Button>
        </ButtonWrapper>
      </GridRow>
    </DashboardContainerSection>
  );
};

DashboardEnquiryList.propTypes = {
  t: PropTypes.func.isRequired,
  widgetName: PropTypes.string,
  widgetId: PropTypes.number,
  userId: PropTypes.number,
  countryId: PropTypes.number,
};

DashboardEnquiryList.defaultProps = {
  widgetName: null,
  widgetId: null,
  userId: null,
  countryId: null,
};

export default withTranslation()(DashboardEnquiryList);
